export const BUTTON_TOOLTIP_DELAY = 800

export const FILTER_STATE = Object.freeze({
  AWAITING_APPROVAL: 1,
  APPROVED: 2,
  REJECTED: 3,
})
